export default {
  USE_DOMAIN: 'use-domain',
  GET_FREE_DOMAIN: 'get-free-subdomain',
  BUY_DOMAIN: 'buy-domain',
};
